import { useMutation } from '@tanstack/react-query';
import {
  setCalendarSync,
  SetCalendarSyncInput,
} from 'shared/services/backend-api';

export const useSetCalendarSyncMutation = () =>
  useMutation({
    mutationFn: async (input: SetCalendarSyncInput) => setCalendarSync(input),
  });
